import React from "react";
import { bool, node, string } from "prop-types";
import { Col, Row } from "../../../Grid";
import Image from "../../../Image";
import Heading from "../../../Heading";
import UList from "../../../UList";
import Block from "../../../Block";
import { classes } from "../../../utils/classes";
import { utilityClassName, utilityProps, utilityPropTypes } from "../../../props/utility";
import { spacingClassName, spacingProps, spacingPropTypes } from "../../../props/spacing";
import { sxClassName, sxProps, sxPropTypes } from "../../../props/sx";

const Title = ({ ...props }) => (
	<Heading Tag="h2" sx={{ fontSize: "m", fontColor: "black" }} spacing={{ mb: 4 }} {...props} />
);

Title.propTypes = {
	...Heading.propTypes,
};

const FeaturesBlockItem = ({ children }) => {
	return <UList.Item spacing={{ mb: 4 }}>{children}</UList.Item>;
};

FeaturesBlockItem.propTypes = {
	children: node.isRequired,
};

const FeaturesBlock = ({
	title,
	imgSrc,
	imgClassName = "",
	isImgFirst = true,
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	className = "",
	children,
}) => {
	const imgSpacingProps = isImgFirst ? { lg: { mr: 12 } } : { lg: { ml: 12 } };
	return (
		<Row
			className={classes(
				...utilityClassName(utility),
				...sxClassName(sx),
				...spacingClassName(spacing),
				className,
			)}
		>
			{isImgFirst ? (
				<>
					<Col lg={6} spacing={{ mb: 4, lg: { mb: 0 } }}>
						<Block sx={{ textAlign: "center" }} spacing={imgSpacingProps}>
							<Image src={imgSrc} className={imgClassName} />
						</Block>
					</Col>
					<Col lg={6}>
						<Title>{title}</Title>
						<UList>{children}</UList>
					</Col>
				</>
			) : (
				<>
					<Col lg={6} className="small-order-2 large-order-1">
						<Title>{title}</Title>
						<UList>{children}</UList>
					</Col>
					<Col lg={6} spacing={{ mb: 4, lg: { mb: 0 } }} className="small-order-1 large-order-2">
						<Block sx={{ textAlign: "center" }} spacing={imgSpacingProps}>
							<Image src={imgSrc} className={imgClassName} />
						</Block>
					</Col>
				</>
			)}
		</Row>
	);
};

FeaturesBlock.propTypes = {
	imgSrc: string.isRequired,
	imgClassName: string,
	isImgFirst: bool,
	title: node.isRequired,
	className: string,
	children: node.isRequired,
	utility: utilityPropTypes,
	sx: sxPropTypes,
	spacing: spacingPropTypes,
};

FeaturesBlock.Item = FeaturesBlockItem;

export default FeaturesBlock;
